import React, { useState } from "react";
import "./About.css";
import { FaLink, FaEnvelope, FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";

import bappi from "/Users/bappihussayn/momentscapture/src/Components/Assests/bappi.jpeg";
import najir from "/Users/bappihussayn/momentscapture/src/Components/Assests/najirnew.JPG";
import shine from "/Users/bappihussayn/momentscapture/src/Components/Assests/shinenew2.jpeg";
import john from "/Users/bappihussayn/momentscapture/src/Components/Assests/ranjannew.jpg";
import hemant from "/Users/bappihussayn/momentscapture/src/Components/Assests/hemant.jpeg";
import noor from "/Users/bappihussayn/momentscapture/src/Components/Assests/nooralam.jpeg";
import sudhir from "/Users/bappihussayn/momentscapture/src/Components/Assests/sudhir.jpeg";
import team from "/Users/bappihussayn/momentscapture/src/Components/Assests/team.png";

const teamMembers = [
  {
    id: 1,
    name: "Bappi Hussayn",
    role: "Chairman & Co-Founder",
    image: bappi,
    email: "bappihussayn@gmail.com",
   
  },
  {
    id: 2,
    name: "Najir Uddin",
    role: "CEO & Co-Founder",
    image: najir,
    email: "anajir143@gmail.com",
   
  },
  // {
  //   id: 3,
  //   name: "Muhammad Shine",
  //   role: "President ",
  //   image: shine,
  //   email: "shine@example.com",
  //   social: {
  //     instagram: "https://instagram.com/_muahmmad_shine_77",
  //   },
  // },
  {
    id: 4,
    name: "Ranjan Kumar",
    role: "Team Lead",
    image: john,
  
  },
  {
    id: 5,
    name: "Noor Alam",
    role: "Cinematographer",
    image: noor,
   
  },
  // {
  //   id: 6,
  //   name: "Vishal Singh",
  //   role: "PhotoGrapher & Videographer",
  //   image: john,
    
  // },
  {
    id: 7,
    name: "Hemant Singh bisht",
    role: "Editor",
    image: hemant,
    
  },
  {
    id: 8,
    name: "Sudhir Sharma",
    role: "Photographer",
    image: sudhir,
    
  },
 
];

const About = () => {
  const [activeMember, setActiveMember] = useState(null);

  const toggleLinks = (id) => {
    setActiveMember(activeMember === id ? null : id);
  };

  return (
    <div className="about-container">
      <h2 className='about-heading'>About Us</h2>
<p className='about-text'>
  Discover MomentsCapture: where stories come to life through captivating visuals. 
  We are passionate storytellers, dedicated to freezing moments in time, 
  turning memories into timeless treasures.
</p>
      <h2>Meet Our Team</h2>
      <div className="team-container">
        {teamMembers.map((member) => (
          <div key={member.id} className="team-card">
            <img src={member.image} alt={member.name} className="team-image" />
            <div className="team-info">
              <h3>{member.name}</h3>
              <p>{member.role}</p>
              
             
            </div>
          </div>
        ))}

        {/* Join Us Card */}
        <div className="team-card">
          <img src={team} alt="Join Us" className="team-image" />
          <div className="team-info">
            <h3>Become a Member</h3>
            <p>Join Us, Grow with Us.</p>
            <p>Email: <a href="mailto:in.momentscapture@gmail.com">in.momentscapture@gmail.com</a></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
